// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d468356f","977":"bba9d4f1"}[chunkId] + ".chunk.js";
};